{{ 'rtr.header.sign_up_text' | translate }}
<span routerLink="/auth/sign_up" margin-left-small-xx>
  {{ 'rtr.header.sign_up' | translate }}
</span>
